import { render, staticRenderFns } from "./TemplateApprovalForm.vue?vue&type=template&id=3793ce65&scoped=true"
import script from "./TemplateApprovalForm.vue?vue&type=script&lang=js"
export * from "./TemplateApprovalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3793ce65",
  null
  
)

export default component.exports